import { render, staticRenderFns } from "./people-table.vue?vue&type=template&id=03a626ca&scoped=true&"
import script from "./people-table.vue?vue&type=script&lang=js&"
export * from "./people-table.vue?vue&type=script&lang=js&"
import style0 from "./people-table.vue?vue&type=style&index=0&id=03a626ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a626ca",
  null
  
)

export default component.exports